import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Remove loading screen
const loading = document.getElementById("loading");
if (loading) {
  loading.style.opacity = "0";
  setTimeout(() => loading.remove(), 500);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
